export enum Provider {
  BPOST = 'BPOST',
  POSTNL = 'POSTNL',
  ROYAL_MAIL = 'ROYAL_MAIL',
  DPD = 'DPD',
}
